class Filter {
    constructor() {
        this.id = null
        this.name = 'Padrão'
        this.branch = null
        this.parent = null
        this.price_min = 0
        this.price_max = 10000
        this.state = null
        this.city = null
        this.dcs = null
        this.brand = null
        this.budget = 0
        this.datetime_created = null
        this.datetime_updated = null
        this.is_new = 0
    }

    static get fieldNames() {
        return {
            id: 'ID',
            name: 'Nome',
            branch: 'Filial',
            parent: 'Árvore de Sortimento',
            price_min: 'Preço mínimo',
            price_max: 'Preço máximo',
            state: 'Estado',
            city: 'Cidade',
            dcs: 'CD(s)',
            brand: 'Fornecedor',
            budget: 'Investimento Total',
            datetime_created: 'Data de Criação',
            datetime_updated: 'Data de Atualização',
            is_new: 'Itens Novos'
        }
    }

    static get fieldTypes() {
        return {
            id: 'number',
            name: 'text',
            branch: 'number',
            parent: 'number',
            price_min: 'number',
            price_max: 'number',
            state: 'text',
            city: 'text',
            dcs: 'text',
            brand: 'text',
            budget: 'number',
            is_new: 'number',
            datetime_created: 'datetime-local',
            datetime_updated: 'datetime-local'
        }
    }

    static get visibleFields() {
        return {
            id: true,
            name: true,
            branch: true,
            parent: true,
            price_min: true,
            price_max: true,
            state: true,
            city: true,
            dcs: true,
            brand: true,
            budget: true,
            is_new: true,
            datetime_created: false,
            datetime_updated: false
        }
    }

    static get editableFields() {
        return {
            // id: false, // omit false
            name: true,
            branch: true,
            parent: true,
            price_min: true,
            price_max: true,
            state: true,
            city: true,
            dcs: true,
            brand: true,
            is_new: true,
            budget: true
            // datetime_created: false,
            // datetime_updated: false
        }
    }
}

export default Filter

export { Filter }
